<template>
  <div>
    <v-card class="pa-0 pb-10" tile>
      <v-card-title>
        <h4 class="primary--text">{{ listName }}</h4>
        <v-btn
            icon
            class="ml-2"
            @click="onBellClick()"
          >
            <v-badge
              :content="getBellMetaForDisplay().count"
              :value="getBellMetaForDisplay().count > 0"
              color="error"
              overlap
            >
              <v-icon :color="getBellMetaForDisplay().hasNew ? 'error' : 'grey lighten-1'">$infoNewOffers</v-icon>
            </v-badge>
          </v-btn>
        <v-tooltip v-if="isGuest && !isMyLinks" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              class="ml-1"
              v-bind="attrs"
              v-on="on"
              @click="openMyInterestsGuest"
            >
              <v-icon color="primary" size="20">
                $interestCount
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('spedilink.offers.myInterests') }}</span>
        </v-tooltip>
        <v-spacer />
        <v-btn outlined @click="onClearFilters">
          {{ $t('spedilink.links.clearFilters') }}
        </v-btn>
        <v-btn outlined class="ml-2" @click="showFilters = !showFilters">
          {{ showFilters ? $t('spedilink.links.hideFilters') : $t('spedilink.links.showFilters') }}
        </v-btn>
        <v-btn v-if="isMyLinks" color="primary" depressed class="ml-2" @click="goToAddFreight">
          {{ $t('spedilink.myLinks.addCargo') }}
        </v-btn>
        <v-btn v-if="isMyLinks" color="primary" depressed class="ml-2" @click="goToAddVehicle">
          {{ $t('spedilink.myLinks.addVehicle') }}
        </v-btn>
      </v-card-title>

      <v-expand-transition>
        <div v-show="showFilters" class="px-6 pb-4">
          <SpedilinkDetailsFilter ref="detailsFilter" :type="isCargo ? 1 : 2" :is-archive-tab="isArchiveTab" @apply="onFilterApply" />
        </div>
      </v-expand-transition>

      <div class="background px-6 my-4">
        <v-tabs
          v-model="activeTab"
          :height="60"
          background-color="background"
          show-arrows
          hide-slider
          center-active
        >
          <v-tab>{{ $t('spedilink.links.aktual') }}</v-tab>
          <v-tab v-if="isMyLinks">{{ $t('spedilink.links.archiwum') }}</v-tab>
        </v-tabs>
      </div>

      <v-card class="py-5">
        <div class="px-4">
          <v-data-table
            :items="currentItems"
            :loading="currentLoading"
            :headers="tableHeaders"
            :item-class="itemRowBackground"
            hide-default-footer
            :items-per-page="pageSize"
            :server-items-length="currentTotalCount"
            @update:options="onSortChange"
            @click:row="openDetails"
          >
            <!-- Loading places -->
            <template v-slot:[`item.loadingPlaces`]="{ item }">
              <div v-if="item.loadingPlaces && item.loadingPlaces[0]" class="d-flex align-center">
                <CountryFlag :country="item.loadingPlaces[0].country" class="mr-1" />
                <div class="d-flex flex-column">
                  <span>
                    {{ item.loadingPlaces[0].country.toUpperCase() }},
                    <span>{{ isCargo ? item.loadingPlaces[0].place.postalCode : item.loadingPlaces[0].postalCode }}</span><br />
                    {{ isCargo ? item.loadingPlaces[0].place.city : item.loadingPlaces[0].city }}
                  </span>
                  <div class="lightText--text">
                    <span>{{ item.loadingPlaces[0].date | dateFormat }} </span>
                    <span v-if="item.loadingPlaces[0].from && item.loadingPlaces[0].to">
                      {{ item.loadingPlaces[0].from }} - {{ item.loadingPlaces[0].to }}
                    </span>
                  </div>
                </div>
                <v-tooltip v-if="item.loadingPlaces.length > 1" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" class="more-data ml-2">+{{ item.loadingPlaces.length - 1 }}</div>
                  </template>
                  <div v-for="(loc, idx) in item.loadingPlaces" :key="idx">
                    <div v-if="idx !== 0" class="d-flex align-center" style="line-height:1.25">
                      <CountryFlag :country="loc.country" class="mr-1" />
                      <div class="d-flex flex-column">
                        <span>{{ loc.country.toUpperCase() }}, {{ isCargo ? loc.place.postalCode : loc.postalCode }} {{ isCargo ? loc.place.city : loc.city }}</span>
                        <span>{{ loc.date | dateFormat }}<span v-if="loc.from && loc.to"> {{ loc.from }} - {{ loc.to }}</span></span>
                      </div>
                    </div>
                  </div>
                </v-tooltip>
              </div>
            </template>

            <!-- Unloading places -->
            <template v-slot:[`item.unloadingPlaces`]="{ item }">
              <div v-if="item.unloadingPlaces && item.unloadingPlaces.length > 0" class="d-flex align-center">
                <CountryFlag :country="item.unloadingPlaces[0].country" class="mr-1" />
                <div class="d-flex flex-column">
                  <span>
                    {{ item.unloadingPlaces[0].country.toUpperCase() }},
                    {{ isCargo ? item.unloadingPlaces[0].place.postalCode : item.unloadingPlaces[0].postalCode }}<br />
                    {{ isCargo ? item.unloadingPlaces[0].place.city : item.unloadingPlaces[0].city }}
                  </span>
                  <div class="lightText--text">
                    <span>{{ item.unloadingPlaces[0].date | dateFormat }} </span>
                    <span v-if="item.unloadingPlaces[0].from && item.unloadingPlaces[0].to">
                      {{ item.unloadingPlaces[0].from }} - {{ item.unloadingPlaces[0].to }}
                    </span>
                  </div>
                </div>
                <v-tooltip v-if="item.unloadingPlaces.length > 1" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" class="more-data ml-2">+{{ item.unloadingPlaces.length - 1 }}</div>
                  </template>
                  <div v-for="(loc, idx) in item.unloadingPlaces" :key="idx">
                    <div v-if="idx !== 0" class="d-flex align-center" style="line-height:1.25">
                      <CountryFlag :country="loc.country" class="mr-1" />
                      <div class="d-flex flex-column">
                        <span>{{ loc.country.toUpperCase() }}, {{ isCargo ? loc.place.postalCode : loc.postalCode }} {{ isCargo ? loc.place.city : loc.city }}</span>
                        <span>{{ loc.date | dateFormat }}<span v-if="loc.from && loc.to"> {{ loc.from }} - {{ loc.to }}</span></span>
                      </div>
                    </div>
                  </div>
                </v-tooltip>
              </div>
            </template>

            <!-- Freight details (cargo) -->
            <template v-slot:[`item.freightDetails`]="{ item }">
              <div class="d-flex align-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <template v-if="item.type && item.type.length === 1">
                        <DisplayIcon v-if="item.type[0].icon" :icon-name="item.type[0].icon" size="26" />
                        <v-icon v-else>$truck</v-icon>
                      </template>
                      <DisplayIcon v-if="item.type && item.type.length > 1" :icon-name="'__icon_MANY_TYPES.svg'" size="26" />
                    </div>
                  </template>
                  <p class="ma-0">
                    <span v-for="(x, i) in item.type" :key="i">{{ x.name }} </span>
                  </p>
                </v-tooltip>
                <div class="d-flex flex-column ml-2">
                  <p class="mb-0">{{ item.vehicleDetails }}</p>
                  <p class="mb-0">{{ item.vehicleDetailsSecondLine }}</p>
                </div>
              </div>
            </template>

            <!-- Price (cargo) -->
            <template v-slot:[`item.price`]="{ item }">
              <div class="d-flex flex-column w-100">
                <p class="mb-0 text-center">{{ item.paymentDetails }}</p>
                <p class="mb-0 text-center">{{ item.paymentDetailsSecondLine }}</p>
              </div>
            </template>

            <!-- Vehicle details (vehicle) -->
            <template v-slot:[`item.vehicleDetails`]="{ item }">
              <div class="d-flex align-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <DisplayIcon v-if="item.iconName" :icon-name="item.iconName" size="26" />
                      <v-icon v-else>$truck</v-icon>
                    </div>
                  </template>
                  <p class="ma-0">{{ item.type }}</p>
                </v-tooltip>
                <div class="d-flex flex-column ml-2">
                  <p class="mb-0">{{ item.vehicleDetails }}</p>
                  <p class="mb-0">{{ item.vehicleDetailsSecondLine }}</p>
                </div>
              </div>
            </template>

            <!-- Availability (vehicle) -->
            <template v-slot:[`item.start`]="{ item }">
              <div class="d-flex align-center ml-4">
                <div class="text-center">{{ item.startDate }}<br />{{ item.startTime }}</div>
                <span class="px-4">-</span>
                <div class="text-center">{{ item.endDate }}<br />{{ item.endTime }}</div>
              </div>
            </template>

            <!-- Publish date -->
            <template v-slot:[`item.publishDate`]="{ item }">
              <div class="text-center">
                {{ item.publishDate | dateFormat('DD.MM.YYYY') }}<br />
                {{ item.publishDate | dateFormat('HH:mm') }}
              </div>
            </template>

            <!-- Publisher -->
            <template v-slot:[`item.publisher`]="{ item }">
              <div v-if="item.publisher" class="d-flex align-center cursor-pointer">
                <StatusAvatar :userId="item.publisher.id" :size="26" showStatus class="mr-2" />
                <div class="d-flex flex-column">
                  <div>{{ item.publisher.name }} {{ item.publisher.surname }}</div>
                  <v-tooltip v-if="item.publisher.company" bottom min-width="220px">
                    <template v-slot:activator="{ on, attrs }">
                      <div class="lightText--text" v-bind="attrs" v-on="on">{{ item.publisher.company.name | trimText(20) }}</div>
                    </template>
                    <v-row class="mt-1">
                      <v-col cols="12">
                        <p>{{ item.publisher.company.name }}<br />NIP: {{ item.publisher.company.vatNumber }}</p>
                        <p>{{ $t('offerDetails.address') }}:<br />{{ item.publisher.company.street }}<br />{{ item.publisher.company.zipCode }}, {{ item.publisher.company.city }}</p>
                      </v-col>
                    </v-row>
                  </v-tooltip>
                </div>
              </div>
            </template>

            <!-- Phone -->
            <template v-slot:[`item.phone`]="{ item }">
              <DataTablePopupCell
                v-if="item.publisher && $store.getters.userCommonData.id !== item.publisher.id"
                :phone="item.publisher.phone"
                :click-type="ClickPhone"
                :order-id="item.id"
              />
            </template>

            <!-- Email -->
            <template v-slot:[`item.mail`]="{ item }">
              <DataTablePopupCell
                v-if="item.publisher && $store.getters.userCommonData.id !== item.publisher.id"
                :subject="item"
                :email="item.publisher.email"
                :click-type="ClickEmail"
                :order-id="item.id"
              />
            </template>

            <!-- WhatsApp -->
            <template v-slot:[`item.whatsapp`]="{ item }">
              <WhatsAppContactButton
                v-if="item.publisher && $store.getters.userCommonData.id !== item.publisher.id"
                :phone="item.publisher.phone"
                :subject="item"
                :click-type="ClickWhatsApp"
                :order-id="item.id"
              />
            </template>

            <!-- Guest interest action -->
            <template v-slot:[`item.chat`]="{ item }">
              <v-btn
                v-if="!isPublicLink && $store.getters.isGuest"
                icon
                small
                color="primary"
                class="pointer btn-express-interest"
                data-prevent-row-click
                @click.stop="openExpressInterest(item)"
              >
                <v-icon size="25" color="primary">$expressInterest</v-icon>
              </v-btn>
            </template>

            <!-- Chat (Spedi Oferty details only; disabled for guests) -->
            <template v-slot:[`item.chatIcon`]="{ item }">
              <template v-if="!isPublicLink && item.publisher && item.publisher.id && (isGuest || $store.getters.userCommonData.id !== item.publisher.id)">
                <v-tooltip v-if="isGuest" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="d-inline-flex">
                      <v-btn
                        icon
                        disabled
                        data-prevent-row-click
                      >
                        <v-icon color="separator" size="21">$chatV2</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>{{ $t('spedilink.offers.chatTooltip') }}</span>
                </v-tooltip>
                <v-btn
                  v-else
                  icon
                  data-prevent-row-click
                  @click.stop="startConversationWithUser(item.publisher.id, item.id)"
                >
                  <v-icon color="separator" size="21">$chatV2</v-icon>
                </v-btn>
              </template>
            </template>

            <!-- Interests icon (my-links only) -->
            <template v-slot:[`item.interests`]="{ item }">
              <v-icon v-if="item.hasInterests" color="primary" size="20">
                $infoOfferPastInterest
              </v-icon>
            </template>

            <!-- Actions (republish in archive + my-links + copy to spedilink) -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-menu
                v-if="(isMyLinks && isOwnOffer(item)) || ($permission('SpedilinkAccess') && !isArchiveTab)"
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-if="isMyLinks && isOwnOffer(item) && isArchiveTab" link @click="onRepublish(item)">
                    <v-list-item-title>{{ $t('spedilink.links.republish') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="isMyLinks && isOwnOffer(item) && !isArchiveTab" link @click="openAddToAnotherListDialog(item)">
                    <v-list-item-title>{{ $t('spedilink.links.addToAnotherList') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="isMyLinks && isOwnOffer(item) && !isArchiveTab" link @click="archiveOffer(item)">
                    <v-list-item-title>{{ $t('spedilink.links.archiveOffer') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="isMyLinks && isOwnOffer(item) && !isAll && !isArchiveTab" link @click="onRemoveFromList(item)">
                    <v-list-item-title class="error--text">{{ $t('spedilink.links.removeFromList') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="$permission('SpedilinkAccess') && !isArchiveTab && !isMyLinks" link @click.stop="openAddToSpedilinkDialog(item)">
                    <v-list-item-title>{{ $t('spedilink.links.addToList') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="$permission('TSLAccess') && !isArchiveTab && !isMyLinks" link @click.stop="openCreateOrderDialog(item)">
                    <v-list-item-title>{{ $t('createOrderFromOffer.menuItem') }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <template v-slot:footer v-if="currentPageCount > 1">
              <v-pagination v-model="currentPage" :length="currentPageCount" />
            </template>
          </v-data-table>
        </div>
      </v-card>

      <v-dialog v-model="expressInterestDialog" max-width="640">
        <v-card>
          <v-card-title>{{ $t('spedilink.offers.expressInterest') }}</v-card-title>
          <v-card-text>
            <v-select
              v-if="isAll"
              v-model="selectedExpressInterestLinkId"
              :items="expressInterestLinks"
              item-text="name"
              item-value="id"
              :label="$t('spedilink.offers.expressInterestSelectLink')"
              :loading="expressInterestLinksLoading"
              :disabled="expressInterestLinksLoading || expressInterestLinks.length === 0"
              outlined
              class="mb-4"
            />
            <v-textarea
              v-model="expressInterestContent"
              outlined
              auto-grow
              rows="4"
              maxlength="200"
              counter="200"
              :label="$t('spedilink.offers.expressInterestContent')"
            />
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="closeExpressInterestDialog">
              {{ $t('common.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              depressed
              :loading="expressInterestLoading"
              :disabled="isAll && (!selectedExpressInterestLinkId || expressInterestLinksLoading)"
              @click="submitExpressInterest"
            >
              {{ $t('spedilink.offers.expressInterestSubmit') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <OfferDetailsDialog
        v-if="selectedOrderId"
        :value="offerDetailsActive"
        :itemId="selectedOrderId"
        :isVehicle="!isCargo"
        :disable-chat="isPublicLink"
        @closed="closeOfferDetailsDialog"
      />

      <AddOfferToAnotherListDialog
        v-if="selectedOfferForMove"
        :value="addToAnotherListDialog"
        :orderId="selectedOfferForMove.id"
        :type="isCargo ? 1 : 2"
        :currentLinkId="listId"
        @close="closeAddToAnotherListDialog"
        @offer-added-to-list="onOfferAddedToList"
      />

      <AddOfferToListDialog
        v-if="selectedSpedilinkOffer"
        v-model="addToSpedilinkDialog"
        :offer-id="selectedSpedilinkOffer.id"
        :type="isCargo ? 1 : 2"
        @close="addToSpedilinkDialog = false"
        @offer-added-to-list="addToSpedilinkDialog = false"
      />

      <MySpediLinkInterestsDialog
        v-model="myInterestsGuestDialog"
        :link-id="isAll ? null : listId"
      />

      <v-dialog v-model="interestsDialog" max-width="900" scrollable>
        <v-card>
          <v-card-title>{{ $t('offerDetails.interests') }}</v-card-title>
          <v-card-text>
            <SpedilinkInterestsPanel
              :interests="selectedInterests"
              :show-archive-actions="true"
              @interest-archived="onInterestArchived"
            />
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn color="primary" depressed @click="interestsDialog = false">
              {{ $t('common.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <Confirm ref="confirm" />
    </v-card>

    <CreateOrderFromOfferDialog
      v-if="createOrderOffer"
      v-model="createOrderDialog"
      :offer="createOrderOffer"
      @input="onCreateOrderDialogInput"
    />
  </div>
</template>

<script>
import Service from '@/services'
import CountryFlag from 'vue-country-flag'
import StatusAvatar from '@/components/StatusAvatar'
import DisplayIcon from '@/components/icons/DisplayIcon'
import DataTablePopupCell from '@/components/DataTablePopupCell'
import WhatsAppContactButton from '@/components/WhatsAppContactButton'
import SpedilinkDetailsFilter from '@/views/Spedilink/components/SpedilinkDetailsFilter'
import OfferDetailsDialog from '@/views/Market/dialogs/OfferDetailsDialog'
import AddOfferToAnotherListDialog from '@/views/Spedilink/dialogs/AddOfferToAnotherListDialog'
import AddOfferToListDialog from '@/views/Spedilink/dialogs/AddOfferToListDialog.vue'
import Confirm from '@/components/dialogs/Confirm.vue'
import MySpediLinkInterestsDialog from '@/views/Spedilink/dialogs/MySpediLinkInterestsDialog'
import SpedilinkInterestsPanel from '@/views/Market/dialogs/panels/SpedilinkInterestsPanel'
import { startConversation } from '@/signalr/chat'
import { Phone as ClickPhone, Email as ClickEmail, WhatsApp as ClickWhatsApp } from '@/types/click-order-types.js'
import { GUID_EMPTY, SPEDILINK_LINK_TYPES, SPEDILINK_ROUTE_NAMES } from '@/views/Spedilink/spedilink-constants'
import { SET_DOCUMENT_TITLE_BASE } from '@/store/mutation-types'
import CreateOrderFromOfferDialog from '@/views/TSL/Orders/dialogs/CreateOrderFromOfferDialog.vue'

const PAGE_SIZE = 20

export default {
  name: 'SpedilinkLinkDetails',
  components: {
    CountryFlag,
    StatusAvatar,
    DisplayIcon,
    DataTablePopupCell,
    WhatsAppContactButton,
    SpedilinkDetailsFilter,
    OfferDetailsDialog,
    AddOfferToAnotherListDialog,
    AddOfferToListDialog,
    Confirm,
    MySpediLinkInterestsDialog,
    SpedilinkInterestsPanel,
    CreateOrderFromOfferDialog
  },
  data () {
    return {
      notificationCount: 0,
      ClickPhone,
      ClickEmail,
      ClickWhatsApp,
      pageSize: PAGE_SIZE,
      listName: '',
      isPublicLink: false,
      showFilters: false,
      activeTab: 0,
      activeConditions: [],
      sortBy: [],
      sortDesc: [],
      offers: [],
      loading: false,
      totalCount: 0,
      pageCount: 1,
      page: 1,
      archivedOffers: [],
      archiveLoading: false,
      archiveTotalCount: 0,
      archivePageCount: 1,
      archivePage: 1,
      offerDetailsActive: false,
      selectedOrderId: null,
      expressInterestDialog: false,
      expressInterestLoading: false,
      expressInterestContent: '',
      expressInterestLinks: [],
      expressInterestLinksLoading: false,
      selectedExpressInterestLinkId: null,
      selectedOfferForInterest: null,
      addToAnotherListDialog: false,
      selectedOfferForMove: null,
      addToSpedilinkDialog: false,
      selectedSpedilinkOffer: null,
      myInterestsGuestDialog: false,
      interestsDialog: false,
      pendingMarkAllInterestsAsRead: false,
      selectedInterests: [],
      currentLinkForInterests: null,
      createOrderDialog: false,
      createOrderOffer: null
    }
  },
  computed: {
    isGuest () {
      return this.$store.getters.isGuest
    },
    listId () {
      return this.$route.params.id
    },
    isAll () {
      return this.listId === GUID_EMPTY
    },
    isCargo () {
      return [SPEDILINK_ROUTE_NAMES.CARGO_LIST, SPEDILINK_ROUTE_NAMES.CARGO_OFFER_LIST].includes(this.$route.name)
    },
    isMyLinks () {
      return [SPEDILINK_ROUTE_NAMES.CARGO_LIST, SPEDILINK_ROUTE_NAMES.VEHICLE_LIST].includes(this.$route.name)
    },
    isArchiveTab () {
      return this.activeTab === 1
    },
    currentItems () {
      return this.isArchiveTab ? this.archivedOffers : this.offers
    },
    currentLoading () {
      return this.isArchiveTab ? this.archiveLoading : this.loading
    },
    currentPageCount () {
      return this.isArchiveTab ? this.archivePageCount : this.pageCount
    },
    currentTotalCount () {
      return this.isArchiveTab ? this.archiveTotalCount : this.totalCount
    },
    spedilinkEventVersion () {
      return this.$store.getters['spedilink/eventVersion']
    },
    spedilinkLastEvent () {
      return this.$store.getters['spedilink/lastEvent']
    },
    currentPage: {
      get () {
        return this.isArchiveTab ? this.archivePage : this.page
      },
      set (val) {
        if (this.isArchiveTab) {
          this.archivePage = val
        } else {
          this.page = val
        }
      }
    },
    tableHeaders () {
      const headers = [
        { text: this.$t('marketTableHeader.load'), value: 'loadingPlaces' },
        { text: this.$t('marketTableHeader.unload'), value: 'unloadingPlaces', sortable: false }
      ]
      if (this.isCargo) {
        headers.push(
          { text: this.$t('marketTableHeader.freightDetails'), value: 'freightDetails', sortable: false },
          { text: this.$t('marketTableHeader.price'), value: 'price', sortable: false }
        )
      } else {
        headers.push(
          { text: this.$t('marketTableHeader.available'), value: 'start' },
          { text: this.$t('marketTableHeader.vehicleDetails'), value: 'vehicleDetails', sortable: false }
        )
      }
      headers.push(
        { text: this.$t('marketTableHeader.publishDate'), value: 'publishDate' },
        { text: this.$t('marketTableHeader.publisher'), value: 'publisher', sortable: false }
      )
      if (!this.isMyLinks && !this.isPublicLink) {
        headers.push({ text: '', value: 'chatIcon', sortable: false })
      }
      headers.push(
        { text: '', value: 'phone', sortable: false },
        { text: '', value: 'mail', sortable: false },
        { text: '', value: 'whatsapp', sortable: false }
      )
      if (!this.isMyLinks && !this.isPublicLink) {
        headers.push({ text: '', value: 'chat', sortable: false })
      }
      if (this.isMyLinks) {
        headers.push({ text: '', value: 'interests', sortable: false })
      }
      headers.push({ text: '', value: 'actions', sortable: false })
      return headers
    }
  },
  async created () {
    await Promise.all([this.fetchListName(), this.loadOffers()])
  },
  mounted () {
    this.updatePageTitle(this.listName)
  },
  beforeDestroy () {
    this.$store.commit(SET_DOCUMENT_TITLE_BASE, null)
    document.title = 'Spedimo'
  },
  watch: {
    page () {
      this.loadOffers()
    },
    archivePage () {
      this.loadArchivedOffers()
    },
    activeTab (newTab) {
      if (newTab === 1 && this.archivedOffers.length === 0) {
        this.loadArchivedOffers()
      }
    },
    spedilinkEventVersion () {
      this.onRealtimeEvent()
    },
    listName (newName) {
      this.updatePageTitle(newName)
    },
    interestsDialog (newVal, oldVal) {
      if (oldVal && !newVal) {
        this.onInterestsDialogClosed()
      }
    }
  },
  methods: {
    itemRowBackground (item) {
      return !item.checked ? 'bgNew' : 'bgRow'
    },
    isOwnOffer (item) {
      // Public link "My offers" tab shows every offer added by employees of the current company,
      // but modification actions (move/archive/remove) must stay restricted to the offer's own publisher.
      return !!(item.publisher && item.publisher.id && item.publisher.id === this.$store.getters.userCommonData.id)
    },
    getBellMetaForDisplay (link) {
      const interests = this.notificationCount
      return {
        count: interests || 0,
        hasNew: (interests || 0) > 0
      }
    },
    openMyInterestsGuest () {
      if (!this.isGuest || this.isMyLinks) {
        return
      }
      this.myInterestsGuestDialog = true
    },
    async onBellClick (linkId) {
      if (!this.isMyLinks) {
        try {
          await Service.post('spedilink/spedilinkoffers/marknewoffersasread', {
            linkId: linkId === GUID_EMPTY ? null : linkId,
            linkType: this.isCargo
              ? SPEDILINK_LINK_TYPES.FREIGHT
              : SPEDILINK_LINK_TYPES.VEHICLE
          })
        } catch (e) {
        }
      } else {
        await this.openInterestsForCurrentList()
        return
      }
      this.notificationCount = 0
      this.updatePageTitle(this.listName, this.notificationCount)
    },
    mapInterest (i, fallbackKey) {
      return {
        id: i?.interestId || i?.InterestId || i?.id || fallbackKey,
        clientName: `${i?.clientFirstName || i?.ClientFirstName || ''} ${i?.clientLastName || i?.ClientLastName || ''}`.trim(),
        clientEmail: i?.clientEmail || i?.ClientEmail || '',
        clientPhone: i?.clientPhone || i?.ClientPhone || '',
        loadingPlace: i?.loadingPlace || i?.LoadingPlace || '',
        unloadingPlace: i?.unloadingPlace || i?.UnloadingPlace || '',
        content: i?.content || i?.Content || '',
        createdAt: i?.createdAt || i?.CreatedAt,
        isOrderArchived: i?.isOrderArchived || i?.IsOrderArchived,
        orderId: i?.orderId || i?.OrderId,
        orderType: i?.orderType || i?.OrderType || '',
        isNew: i?.isNew || i?.IsNew || false
      }
    },
    async openInterestsForCurrentList () {
      const link = { id: this.isAll ? GUID_EMPTY : this.listId }
      this.interestsDialog = true
      this.currentLinkForInterests = link
      this.selectedInterests = []
      this.pendingMarkAllInterestsAsRead = false
      try {
        const getInterestsParams = link.id === GUID_EMPTY ? {} : { linkId: link.id }
        const { data } = await Service.get('spedilink/SpediLinks/GetInterests', getInterestsParams)
        const raw = data?.results || data?.Results || data
        const list = Array.isArray(raw) ? raw : []
        this.selectedInterests = list.map((i, idx) => this.mapInterest(i, `${link.id}-${idx}`))
      } catch (e) {
        this.selectedInterests = []
      }

      try {
        const hasNew = this.selectedInterests.some(i => i?.isNew)
        if (hasNew) {
          if (link.id === GUID_EMPTY) {
            this.pendingMarkAllInterestsAsRead = true
          } else {
            await Service.post('spedilink/SpediLinks/MarkInterestsAsRead', {
              linkId: link.id,
              linkType: this.isCargo
                ? SPEDILINK_LINK_TYPES.FREIGHT
                : SPEDILINK_LINK_TYPES.VEHICLE
            })
            this.notificationCount = 0
            this.updatePageTitle(this.listName, this.notificationCount)
          }
        }
      } catch (e) {
      }
    },
    async onInterestsDialogClosed () {
      if (!this.pendingMarkAllInterestsAsRead) {
        return
      }

      this.pendingMarkAllInterestsAsRead = false
      try {
        await Service.post('spedilink/SpediLinks/MarkInterestsAsRead', {
          linkId: null,
          linkType: this.isCargo
            ? SPEDILINK_LINK_TYPES.FREIGHT
            : SPEDILINK_LINK_TYPES.VEHICLE
        })
        this.notificationCount = 0
        this.updatePageTitle(this.listName, this.notificationCount)
      } catch (e) {
      }
    },
    async onInterestArchived () {
      if (this.currentLinkForInterests) {
        try {
          const link = this.currentLinkForInterests
          const getInterestsParams = link.id === GUID_EMPTY ? {} : { linkId: link.id }
          const { data } = await Service.get('spedilink/SpediLinks/GetInterests', getInterestsParams)
          const raw = data?.results || data?.Results || data
          const list = Array.isArray(raw) ? raw : []
          this.selectedInterests = list.map((i, idx) => this.mapInterest(i, `${link.id}-${idx}`))
        } catch (e) {
        }
      }
      await this.loadOffers()
    },
    updatePageTitle (name, counter) {
      let title
      if (name) {
        const shortName = name.substring(0, 10)
        if (counter > 0) {
          title = `Spedilink - ${shortName} (${counter})`
        } else {
          title = `Spedilink - ${shortName}`
        }
      } else {
        title = 'Spedilink'
      }
      document.title = title
      this.$store.commit(SET_DOCUMENT_TITLE_BASE, title)
    },
    startConversationWithUser (userId, threadAssociatedItem) {
      startConversation(userId, threadAssociatedItem)
    },
    isInteractiveRowClick (event) {
      const el = event?.target
      if (!el || typeof el.closest !== 'function') return false

      return Boolean(
        el.closest(
          'button, a, input, textarea, select, [role="button"], .v-btn, .v-menu, .v-input, .v-select, [data-prevent-row-click]'
        )
      )
    },
    openDetails (item, event) {
      item.checked = true
      if (this.isInteractiveRowClick(event)) {
        return
      }
      if (!item?.id) {
        return
      }
      this.selectedOrderId = item.id
      this.offerDetailsActive = true
    },
    closeOfferDetailsDialog () {
      this.offerDetailsActive = false
      this.selectedOrderId = null
    },
    async onRealtimeEvent () {
      const event = this.spedilinkLastEvent
      if (!event) return

      const isOrderEvent = ['LinkOrderAdded', 'LinkOrderModified', 'LinkOrderRemoved'].includes(event.eventName)
      if (isOrderEvent) {
        if (event.eventName === 'LinkOrderAdded' && !this.isMyLinks && (this.isAll || event.linkId === this.listId)) {
          this.notificationCount++
          this.updatePageTitle(this.listName, this.notificationCount)
        }
        if (this.isAll || event.linkId === this.listId) {
          await this.loadOffers()
          if (this.isArchiveTab) {
            await this.loadArchivedOffers()
          }
        }
        return
      }
      if (event.eventName === 'NewInterest') {
        if (event.linkId === this.listId || this.listId === GUID_EMPTY) {
          this.notificationCount++
          this.updatePageTitle(this.listName, this.notificationCount)
        }
      }

      if (event.eventName === 'ListRemoved' && !this.isAll && event.linkId === this.listId) {
        // User may have been removed from this link; refresh data context.
        await Promise.all([this.fetchListName(), this.loadOffers()])
      }

      if (event.eventName === 'NewOffersRead') {
        if (!this.isMyLinks && (this.isAll || event.linkId === this.listId)) {
          this.notificationCount = 0
          this.updatePageTitle(this.listName, this.notificationCount)
        }
      }

      if (event.eventName === 'InterestsRead') {
        if (this.isMyLinks && (event.linkId === this.listId || this.listId === null || event.linkId === null)) {
          this.notificationCount = 0
          this.updatePageTitle(this.listName, this.notificationCount)
        }
      }
    },
    linkNameFromRouteQuery () {
      const q = this.$route.query.linkName
      if (q === undefined || q === null) return null
      const s = Array.isArray(q) ? q[0] : q
      const str = String(s).trim()
      return str.length ? str : null
    },
    async fetchListName () {
      if (this.isAll) {
        this.listName = this.$t('spedilink.links.wszystkie')
        return
      }
      // isPublicLink must be resolved from the query regardless of which branch below
      // sets listName - it was previously being skipped whenever linkName was present in
      // the query, so the public link flag never reached this component.
      this.isPublicLink = this.$route.query.isPublicLink === '1'

      const fromQuery = this.linkNameFromRouteQuery()
      if (fromQuery) {
        this.listName = fromQuery
        return
      }
      // Spedi Oferty: subskrybenci często nie mają dostępu do GET details — nie wołaj EP.
      if (!this.isMyLinks) {
        this.listName = ''
        return
      }
      try {
        const { data } = await Service.get(`spedilink/SpediLinks/details/${this.listId}`)
        this.listName = data.name || ''
        this.isPublicLink = !!(data.isPublicLink ?? data.IsPublicLink)
      } catch (e) {
        this.listName = ''
      }
    },
    buildParams (showArchived, page) {
      const params = {
        ShowArchived: showArchived,
        ShowMyOffers: this.isMyLinks,
        Page: page,
        PageSize: PAGE_SIZE
      }
      if (!this.isAll) {
        params.SpediLinkId = this.listId
      }
      if (this.activeConditions.length > 0) {
        params.Conditions = JSON.stringify(this.activeConditions)
      }
      if (this.sortBy.length > 0) {
        params.SortableProperties = JSON.stringify(
          this.sortBy.map((col, idx) => ({
            type: this.sortDesc[idx] ? 1 : 0,
            propertyName: this.getSortPropertyName(col),
            priority: idx
          }))
        )
      }
      return params
    },
    getSortPropertyName (column) {
      const map = {
        loadingPlaces: 'Start',
        start: 'Start',
        unloadingPlaces: 'End',
        publishDate: 'PublishDate'
      }
      return map[column] || column
    },
    onSortChange ({ sortBy, sortDesc }) {
      if (
        JSON.stringify(sortBy) === JSON.stringify(this.sortBy) &&
        JSON.stringify(sortDesc) === JSON.stringify(this.sortDesc)
      ) {
        return
      }
      this.sortBy = [...sortBy]
      this.sortDesc = [...sortDesc]
      this.page = 1
      this.archivePage = 1
      this.loadOffers()
      if (this.isArchiveTab) {
        this.loadArchivedOffers()
      }
    },
    endpoint () {
      return this.isCargo
        ? 'spedilink/SpediLinkOffers/GetFreights'
        : 'spedilink/SpediLinkOffers/GetVehicles'
    },
    async loadOffers () {
      this.loading = true
      try {
        const { data } = await Service.get(this.endpoint(), this.buildParams(false, this.page))
        this.offers = data.Results || data.results || []
        const total = data.TotalCount ?? data.totalCount ?? data.count ?? 0
        this.totalCount = total
        this.pageCount = Math.ceil(total / PAGE_SIZE) || 1
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    async loadArchivedOffers () {
      this.archiveLoading = true
      try {
        const { data } = await Service.get(this.endpoint(), this.buildParams(true, this.archivePage))
        this.archivedOffers = data.Results || data.results || []
        const total = data.TotalCount ?? data.totalCount ?? data.count ?? 0
        this.archiveTotalCount = total
        this.archivePageCount = Math.ceil(total / PAGE_SIZE) || 1
      } catch (e) {
      } finally {
        this.archiveLoading = false
      }
    },
    onFilterApply (conditions) {
      this.activeConditions = conditions
      this.page = 1
      this.archivePage = 1
      this.loadOffers()
      if (this.isArchiveTab) {
        this.loadArchivedOffers()
      }
    },
    onClearFilters () {
      if (this.$refs.detailsFilter) {
        this.$refs.detailsFilter.clearFilters()
      } else {
        this.onFilterApply([])
      }
    },
    onRepublish (item) {
      const routeName = this.isCargo ? 'CopyFreight' : 'CopyVehicle'
      this.$router.push({ name: routeName, params: { id: item.id } })
    },
    goToAddFreight () {
      this.$router.push('/market/freight/add')
    },
    goToAddVehicle () {
      this.$router.push('/market/vehicle/add')
    },
    openExpressInterest (item) {
      this.selectedOfferForInterest = item
      this.expressInterestContent = ''
      this.expressInterestLinks = []
      this.selectedExpressInterestLinkId = null
      this.expressInterestDialog = true
      if (this.isAll) {
        this.loadLinksForOffer(item)
      }
    },
    closeExpressInterestDialog () {
      this.expressInterestDialog = false
      this.selectedOfferForInterest = null
      this.expressInterestContent = ''
      this.expressInterestLinks = []
      this.expressInterestLinksLoading = false
      this.selectedExpressInterestLinkId = null
    },
    async loadLinksForOffer (item) {
      this.expressInterestLinksLoading = true
      try {
        const { data } = await Service.get('spedilink/SpediLinkOffers/GetLinksForOrder', { OrderId: item.id })
        this.expressInterestLinks = data
        if (data.length > 0) {
          this.selectedExpressInterestLinkId = data[0].id
        }
      } catch (e) {
        this.expressInterestLinks = []
      } finally {
        this.expressInterestLinksLoading = false
      }
    },
    resolveExpressInterestLinkId () {
      if (!this.isAll) {
        return this.listId
      }
      return this.selectedExpressInterestLinkId
    },
    async submitExpressInterest () {
      if (!this.selectedOfferForInterest) {
        return
      }
      const linkId = this.resolveExpressInterestLinkId()
      if (!linkId) {
        await this.$store.dispatch('setErrorNotification', this.$t('spedilink.offers.expressInterestMissingLinkId'))
        return
      }
      this.expressInterestLoading = true
      try {
        await Service.post('spedilink/SpediLinkOffers/ExpressInterest', {
          linkId,
          orderId: this.selectedOfferForInterest.id,
          content: this.expressInterestContent || ''
        })
        await this.$store.dispatch('setSuccessNotification', this.$t('spedilink.offers.expressInterestSuccess'))
        this.closeExpressInterestDialog()
      } catch (e) {
      } finally {
        this.expressInterestLoading = false
      }
    },
    async onRemoveFromList (item) {
      this.loading = true
      try {
        await Service.delete('spedilink/SpediLinks/RemoveOrder', {
          LinkIds: [this.listId],
          OrderId: item.id
        })
        await this.$store.dispatch('setSuccessNotification', this.$t('spedilink.links.removeFromListSuccess'))
        await this.loadOffers()
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    openAddToAnotherListDialog (item) {
      this.selectedOfferForMove = item
      this.addToAnotherListDialog = true
    },
    openAddToSpedilinkDialog (item) {
      this.selectedSpedilinkOffer = item
      this.addToSpedilinkDialog = true
    },
    closeAddToAnotherListDialog () {
      this.addToAnotherListDialog = false
      this.selectedOfferForMove = null
    },
    async onOfferAddedToList () {
      await this.$store.dispatch('setSuccessNotification', this.$t('spedilink.links.manageListAssignmentSuccess'))
      await this.loadOffers()
    },
    openCreateOrderDialog (item) {
      const company = item.publisher && item.publisher.company ? item.publisher.company : {}
      this.createOrderOffer = {
        vatNumber: company.vatNumber || null,
        companyName: company.name || null,
        companyId: company.id || item.companyId || null,
        street: company.street || null,
        zipCode: company.zipCode || null,
        city: company.city || null,
        country: company.country || null,
        phone: item.publisher ? item.publisher.phone : null,
        email: item.publisher ? item.publisher.email : null,
        loadingPlaces: item.loadingPlaces || [],
        unloadingPlaces: item.unloadingPlaces || []
      }
      this.createOrderDialog = true
    },
    onCreateOrderDialogInput (val) {
      this.createOrderDialog = val
      if (!val) {
        this.createOrderOffer = null
      }
    },
    async archiveOffer (item) {
      const confirmed = await this.$refs.confirm.open(
        this.$t('spedilink.links.archiveOfferTitle'),
        this.$t('spedilink.links.archiveOfferMessage')
      )
      if (!confirmed) {
        return
      }
      this.loading = true
      try {
        await Service.post('Order/Reject', {
          orderId: item.id
        })
        await this.$store.dispatch('setSuccessNotification', this.$t('spedilink.links.archiveOfferSuccess'))
        await this.loadOffers()
      } catch (e) {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.v-tab::before {
  display: block;
  content: attr(title);
  font-weight: bold;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
.v-tab:hover {
  color: var(--v-primary-base) !important;
  text-shadow: 0 0 .7px var(--v-primary-base), 0 0 .7px var(--v-primary-base);
}
.v-tab--active:hover,
.v-tab--active {
  font-weight: bold;
  color: var(--v-primary-base) !important;
  text-shadow: none;
}
.v-tab {
  border-left: solid 1px var(--v-separator-base);
  margin: 10px 0;
}
.v-tab:last-child {
  border-right: solid 1px var(--v-separator-base);
  margin: 10px 0;
}
</style>
